import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.scss';

import { motion } from 'framer-motion';
import { faGear } from '@fortawesome/free-solid-svg-icons';

export default function DetailsComponent() {
  return (
    <section id={styles.wrapper}>
      <motion.span animate={{ rotate: 360 }} transition={{ repeat: Infinity, duration: 2, ease: 'linear' }}><FontAwesomeIcon icon={faGear} color='#424242' size='3x' /></motion.span>
      <h1>Under Development</h1>
    </section>
  )
}
